module.exports = __webpack_public_path__ + "static/media/bg_stillalbum26bfb21ee727c059e64a4e4021831bfe.webp";